import React from 'react';
import { Col, Row } from 'react-bootstrap';
import TanStackTable from '@spark/ui-components/components/TanStackTable/TanStackTable';
import { getFiliaisOuvidoriaColumns } from './tanStackColumns';

const FiliaisOuvidoriaTable = ({
  data,
  loading,
  onRowClick,
  onEditar,
  onExcluir,
  manualPagination = false,
  totalRegistros = 0,
  controlledPagination,
  onPaginationChange,
}) => (
  <Row>
    <Col md={12}>
      <TanStackTable
        columns={getFiliaisOuvidoriaColumns({ onEdit: onEditar, onDelete: onExcluir })}
        data={data}
        onRowClick={onRowClick}
        isSortable={true}
        withPagination={true}
        pageSizeOptions={[5, 10, 25, 50, 100]}
        enableRowColors={true}
        loading={!!loading}
        className="mt-3"
        manualPagination={manualPagination}
        totalItems={totalRegistros}
        onPaginationChange={onPaginationChange}
        controlledPagination={controlledPagination}
      />
    </Col>
  </Row>
);

export default FiliaisOuvidoriaTable;
